import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgClass, DatePipe } from '@angular/common';
import { IconComponent } from '@teamfoster/sdk/icon';
import { ResizePipe } from '@teamfoster/sdk/image';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NgClass, IconComponent, DatePipe, ResizePipe],
})
export class CardComponent {
  readonly imageUrl = input<string>();
  readonly imageAnchor = input<
    | 'topleft'
    | 'topcenter'
    | 'topright'
    | 'middleleft'
    | 'middlecenter'
    | 'middleright'
    | 'bottomleft'
    | 'bottomcenter'
    | 'bottomright'
    | undefined
  >();
  readonly videoUrl = input<string>();
  readonly title = input<string>();
  readonly subTitle = input<string>();
  readonly text = input<string>();
  readonly date = input<Date | string | number>();
  readonly endDate = input<Date | string>();
  readonly author = input<string>();
  readonly link = input<string[]>();
  readonly showTime = input<boolean>();
  readonly showDate = input<boolean>();
  readonly size = input<string>();
  readonly label = input<string>();

  readonly dateObj = computed(() => {
    const date = this.date();
    return date === undefined || date === null || date === '' ? undefined : new Date(date);
  });

  readonly endDateObj = computed(() => {
    const endDate = this.endDate();
    return endDate === undefined || endDate === null || endDate === '' ? undefined : new Date(endDate);
  });
}
